const DEFAULT_SSR_USER_AGENT = "PPCBlue-App/1.0";

export const withServerUserAgent = (headers: Record<string, string>) => {
  if (typeof window !== "undefined") {
    return headers;
  }

  const userAgent = process.env.SSR_USER_AGENT || DEFAULT_SSR_USER_AGENT;

  return {
    "User-Agent": userAgent,
    ...headers,
  };
};
